import axios from "axios";
export const classMaster = {
  data() {
    return {
      classMastersList: [],
      classMastersWithAllList: [],
      overlay: false,
    };
  },
  mounted() {},
  methods: {
    async getclassMasterListMethod() {
      try {
        let data = JSON.stringify({});
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: this.getDynamicRestAPIUrlMethod(),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": this.getDynamicRestAPIKeyMethod(),
          },
          data: data,
        };
        let result = await axios(config);
        if (result.status == 200 && result.data && result.data.status && result.data.status == "Success") {
          this.classMastersList = result.data.data.Items.map((commonObj) => commonObj.class_name);
          for (const classMaster of this.classMastersList) {
            this.classMastersWithAllList.push(classMaster);
          }
          this.classMastersWithAllList.unshift("All");
        }
      } catch (error) {
        throw error;
      }
    },
    getDynamicRestAPIUrlMethod() {
      return window.location.hostname === "dev.commdealdata.com" || window.location.hostname === "www.dev.commdealdata.com"
        ? "https://auqtxhrtrl.execute-api.us-east-1.amazonaws.com/dv/listclasses"
        // ? "https://7mw4ny54cc.execute-api.us-east-1.amazonaws.com/dev/listclasses" - old dev
        : window.location.hostname === "test.commdealdata.com" || window.location.hostname === "www.test.commdealdata.com" || window.location.hostname == "localhost"
        ? "https://iepve9v0rg.execute-api.us-east-1.amazonaws.com/qa/listclasses"
        // ? "https://a9fb1td1g1.execute-api.us-east-1.amazonaws.com/test/listclasses" - old test
        : window.location.hostname === "uat.commdealdata.com" || window.location.hostname === "www.uat.commdealdata.com"
        ? "https://d1f7r2w2n1.execute-api.us-east-1.amazonaws.com/uat/listclasses"
        : "https://401a68okke.execute-api.us-east-1.amazonaws.com/live/listclasses";
    },
    getDynamicRestAPIKeyMethod() {
      return window.location.hostname === "dev.commdealdata.com" || window.location.hostname === "www.dev.commdealdata.com"
        ? "SXUET0qbEx2hrUogtD4nHWh4BlLtvUi9W2MHiKBg" // "Df77h95pAo76hNjGGxjQTaYEiaN0CR2z179805yW" - old key
        : window.location.hostname === "test.commdealdata.com" || window.location.hostname === "www.test.commdealdata.com" || window.location.hostname == "localhost"
        ? "O7vlIPISux2w3CrqIk69A6Dwz0Wd1Rsw3UrYJiR4" // "xSGhbOtd6g2DYh5PhhOJ77HPFFYAQziDCst97SZ7" - old test
        : window.location.hostname === "uat.commdealdata.com" || window.location.hostname === "www.uat.commdealdata.com"
        ? "iORDwCSXHl670CUuvVuo10kvpylJw7I7KdBqatWc"
        : "w6QQeRLHshapYVbYT94aX9TCJCl75pc37oW3BrOb";
    },
  },
};
